import React, {Fragment} from 'react';
import {Skeleton, Stack} from '@mui/material';

import {StyledGrid} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {Loading} from 'presentation/components/Loading/Loading';
import {StyledCardBox, StyledCardDetailsStack} from './styles';

const {loading} = translations['pt-br'].commons;

export function LoadingState() {
	const {aboveTablet} = useMediaQueries();

	return (
		<Fragment>
			{aboveTablet ? (
				<Fragment>
					<StyledGrid.Item md={6} lg={6}>
						<StyledCardBox>
							<Loading size={32} color="inherit" text={loading} />
						</StyledCardBox>
					</StyledGrid.Item>
					<StyledGrid.Item md={6} lg={6}>
						<StyledCardDetailsStack>
							<Skeleton sx={{transform: 'initial'}} height={32} width="50%" />
							<Skeleton sx={{transform: 'initial'}} height={60} />
							<Skeleton sx={{transform: 'initial'}} height={60} />
							<Skeleton sx={{transform: 'initial'}} height={60} />
							<Skeleton sx={{transform: 'initial'}} height={60} />
							<Skeleton sx={{transform: 'initial'}} height={60} />
						</StyledCardDetailsStack>
					</StyledGrid.Item>
				</Fragment>
			) : (
				<StyledGrid.Item sm={12} m={4}>
					<Stack gap={2}>
						<Skeleton sx={{transform: 'initial'}} height={32} width="50%" />
						<Skeleton sx={{transform: 'initial'}} height={60} />
						<Skeleton sx={{transform: 'initial'}} height={60} />
						<Skeleton sx={{transform: 'initial'}} height={60} />
						<Skeleton sx={{transform: 'initial'}} height={60} />
					</Stack>
				</StyledGrid.Item>
			)}
		</Fragment>
	);
}
